import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class RolesService {

  static getAll(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      let searchPart = isSearch ? '/search/findBySerch' : '';
      axios.get(`${ROOT}roles${params}`).then((data) => {
        resolve({ roles: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllByRoleType(roleTypeId, options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}${k=='sort'?',ignoreCase':''}`)).join('&');
      axios.get(`${ROOT}roles/role-type/${roleTypeId}${params}`).then((data) => {
        resolve({ roles: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}roles/listAll`).then((data) => {
        resolve({ roles: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static rolesToUsers(groupingId = null) {
    let params = ''
    if (groupingId) {
      params = '?groupingId='+groupingId
    }
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}roles/rolesToUsers${params}`).then((data) => {
        resolve({ roles: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAllForRoleType(roleTypeToken) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}roles/listAll?roleTypeToken=${roleTypeToken}`).then((data) => {
        resolve({ roles: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(roleId, includeUsers = false) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}roles/${roleId}?includeUsers=${includeUsers}`).then((data) => {
        resolve({ role: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static remove(role) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}roles/${role.id}`).then((data) => {
        resolve({ role: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(role) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}roles`, role).then((data) => {
        resolve({ role: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static update(role) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}roles/${role.id}`, role).then((data) => {
        resolve({ role: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static saveGroupingsToRole(roleId, groupings) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}roles/${roleId}/groupings`, groupings).then((data) => {
        resolve({ role: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static addGrouping(roleId, grouping) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}roles/${roleId}/groupings`, grouping).then((data) => {
        resolve({ role: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static removeGrouping(roleId, groupingId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}roles/${roleId}/groupings/${groupingId}`).then((data) => {
        resolve({ role: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllRoleTypes() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}roles/types`).then((data) => {
        resolve({ roleTypes: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default RolesService;
